// tatu-app/src/services/api.js
import axios from "axios";

// 1. Detecta o fuso horário do navegador UMA VEZ na inicialização
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// 2. Cria uma instância do Axios com as configurações padrão
const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // Já pega a URL correta (.env)
    headers: {
        'Content-Type': 'application/json',
        'X-Timezone': userTimezone // <--- O Header Global está aqui!
    }
});

// 3. Interceptor de Requisição (Middleware do Front)
// Isso roda ANTES de cada request sair. Ótimo para injetar o Token dinamicamente.
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('tatu_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// 4. (Opcional) Interceptor de Resposta
// Se der erro 401 (Sessão expirada), você pode deslogar o usuário automaticamente aqui.
api.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        // Opcional: Limpar token e redirecionar
        localStorage.removeItem('tatu_token');
        window.location.href = '#/admin';
    }
    return Promise.reject(error);
});

export default api;